<template>
  <div class="wt-dropdown-field wt2-sg">
    <div class="-field-label">
      {{ field.label }}
    </div>

    <div class="-field-control wt-co-dropdown" :class="{ '-open': isOpen }">
      <div
        class="wt-input-holder -autocomplete-input-wrapper"
        v-if="useAutoComplete"
      >
        <input
          type="text"
          class="-field-control wt2-input -autocomplete-input"
          v-model="autocompleteValue"
          @focus="
            showAllOptions = true;
            isOpen = true;
          "
          @input="
            showAllOptions = false;
            isOpen = true;
          "
          @blur="onAutocompleteBlur"
        />
        <div class="-open-close-menu" @click="toggleMenu(true)">
          <i v-if="isOpen" class="wticon wticon-chevron-up" />
          <i v-else class="wticon wticon-chevron-down" />
        </div>
      </div>
      <button v-else class="wt-button hollow-dark" @click="toggleMenu">
        <span class="-ellipsis" :data-name="field.name">
          {{ dropDownValueDisplay }}
        </span>
        <i v-if="isOpen" class="wticon wticon-chevron-up" />
        <i v-else class="wticon wticon-chevron-down" />
      </button>
      <ul class="-list" :style="listStyle" ref="list">
        <li
          v-for="(option, i) in options"
          :key="i"
          class="-item"
          :style="itemStyle"
          @click="selectItem($event, option)"
        >
          <span class="-ellipsis" v-text-right="{ animateSpeed: 1 }">
            {{ option.label || option.id }}
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import fieldsMixin from '../mixins/fields.vue';

export default {
  props: {
    field: {
      type: Object,
      required: true,
      validator(value) {
        return _.every(
          ['defaultValue', 'optionThumbnails', 'label', 'name'],
          (prop) => _.includes(_.keys(value), prop)
        );
      },
    },
    itemHeight: { type: Number, default: 30 },
    numItems: { type: Number, default: 8 },
  },

  mixins: [fieldsMixin],

  data() {
    return {
      guid: app.guid(),
      isOpen: false,
      kaHandlers: [
        {
          on: 'keydown',
          key: $.ui.keyCode.ESCAPE,
          run: () => {
            this.isOpen = false;
          },
        },
      ],
      dropDownValue: '',
      openToTop: false,
      autocompleteValue: '',
      showAllOptions: false,
      useAutoComplete: false,
    };
  },

  beforeDestroy() {
    document.removeEventListener('click', this.$_clickOutside);
    app.keyboardAccessibility.remove(this.guid);
  },

  created() {
    if (this.field.value) {
      this.dropDownValue = this.field.value;
    } else if (this.field.optionThumbnails.length) {
      let defaultOption = this.field.optionThumbnails.find(
        (o) => o.id === this.field.defaultValue
      );
      defaultOption = defaultOption || this.field.optionThumbnails[0];
      this.dropDownValue = defaultOption.id;
    } else {
      this.dropDownValue = this.field.defaultValue;
    }

    this.emitChange({ newValue: this.dropDownValue, makeDirty: false });
    this.$watch('dropDownValue', (newValue) => {
      this.emitChange({ newValue });
    });
  },

  mounted() {
    this.fieldReadyNextTick();
    document.addEventListener('click', this.$_clickOutside);
    this.useAutoComplete = this.field.optionThumbnails.length > 10;
  },

  watch: {
    isOpen() {
      if (this.isOpen) {
        app.keyboardAccessibility.add(this.guid, this.kaHandlers);
        this.$emit('opened');
        this.setMenuPosition();
        this.$nextTick(() => {
          this.scrollToCurrentValue();
        });
      } else {
        app.keyboardAccessibility.remove(this.guid);
      }
    },
    dropDownValueDisplay() {
      this.autocompleteValue = this.dropDownValueDisplay;
    },
    options() {
      this.$nextTick(() => {
        this.setMenuPosition();
      });
    },
  },

  computed: {
    options() {
      if (this.useAutoComplete && !this.showAllOptions) {
        return this.field.optionThumbnails.filter((o) => {
          const labelToFilter = o.label || o.id;
          return labelToFilter
            .toLowerCase()
            .includes(this.autocompleteValue.toLowerCase());
        });
      } else {
        return this.field.optionThumbnails;
      }
    },

    listStyle() {
      const height = this.itemHeight * this.numItems;
      return {
        maxHeight: `${height}px`,
        transform: this.openToTop ? 'translateY(-100%)' : '',
        top: this.openToTop ? '0' : '',
      };
    },

    itemStyle() {
      return {
        height: `${this.itemHeight}px`,
      };
    },

    dropDownValueDisplay() {
      let value = this.dropDownValue;
      this.field.optionThumbnails.forEach((v) => {
        if (v.label && v.id === value) {
          value = v.label;
        }
      });
      return value;
    },
  },

  methods: {
    resetAutocompleteValue() {
      this.autocompleteValue = this.dropDownValueDisplay;
    },
    setMenuPosition() {
      if (this.isOpen) {
        const rect = this.$el.getBoundingClientRect();
        const listRect = this.$refs.list.getBoundingClientRect();
        const parentRect = document
          .querySelector('.wt-custom-overlay-fields')
          ?.getBoundingClientRect();
        const bottom = rect.top - parentRect.top + listRect.height + 100;
        this.openToTop = bottom > parentRect.height;
      }
    },

    onAutocompleteBlur(e) {
      // console.log(e);
      this.$nextTick(() => {
        // console.log(this.isOpen);
        // this.isOpen = false;
        // if (this.autocompleteValue !== this.dropDownValueDisplay) {
        //   this.autocompleteValue = this.dropDownValueDisplay;
        // }
      });
    },

    scrollToCurrentValue() {
      const index = this.options.findIndex((o) => o.id === this.dropDownValue);
      if (index >= 0) {
        const list = this.$refs.list;
        const item = list.children[index];
        const itemRect = item.getBoundingClientRect();
        const listRect = list.getBoundingClientRect();
        const itemTop = itemRect.top - listRect.top;
        const itemBottom = itemRect.bottom - listRect.top;
        const listHeight = listRect.height;
        if (itemTop < 0) {
          list.scrollTop += itemTop;
        } else if (itemBottom > listHeight) {
          list.scrollTop += itemTop;
        }
      }
    },

    toggleMenu(showAllOptions) {
      this.showAllOptions = showAllOptions;
      this.isOpen = !this.isOpen;
    },

    selectItem(e, option) {
      this.isOpen = false;
      this.dropDownValue = option.id;
    },

    $_clickOutside(e) {
      const isAttached = document.body.contains(e.target);
      const isInside = this.$el.contains(e.target);
      if (isAttached && !isInside) {
        this.isOpen = false;
        this.resetAutocompleteValue();
      }
    },
  },
};
</script>
